import * as React from 'react';
import { IMaterial } from '../../utils/manageBudgetMaterial';

const quantityStyle = { textAlign: 'center' };

const ItemBudget: React.SFC<IMaterial> = props => (
  <tr className="table-row">
    <td className="table-col prd-desc">{props.name}</td>
    <td className="table-col sku">{props.sku}</td>
    <td className="table-col quantity" style={quantityStyle}>{props.qty}</td>
  </tr>
);

export default ItemBudget;



// WEBPACK FOOTER //
// ./src/components/Budget/ItemBudget.tsx